/**
 * Which surface the observation presentation is showing. Pure, so the two
 * transitions below are unit-testable straight from
 * __tests__/components/mapSlideshowStage.test.ts.
 */
export type SlideshowStage = 'closed' | 'panel' | 'fullscreen';

/**
 * Which surface "Present observations" opens into. Sept 9 2026 client
 * decision: always the fullscreen overlay. The docked panel is still a
 * stage a presenter can reach on the desktop shell, but only through the
 * Dock button once the presentation is already open, never on open itself.
 */
export function resolveOpenStage(): SlideshowStage {
  return 'fullscreen';
}

/**
 * Where the fullscreen overlay's close (X, Escape, or the browser leaving
 * fullscreen) lands. Sept 9 2026 client decision: it always ends the
 * presentation. Reaching the panel from fullscreen is now a deliberate
 * Dock action, not something a close or an Escape falls back to.
 */
export function resolveExitFullscreenStage(): SlideshowStage {
  return 'closed';
}
